const styles = (theme) => ({
    containerCards: {
        marginTop: '20px',
    },
    card: {
        // minWidth: 275,
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer',
    },
    divCard: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
    cardHeader: {
        padding: '0',
    },
    avatar: {
        width: '60px',
        height: '60px',
        '&.first': {
            backgroundColor: '#00BFB8',
        },

        '&.second': {
            backgroundColor: '#0070A2',
        },

        '&.third': {
            backgroundColor: '#E99B2C',
        },

        '&.fourth': {
            backgroundColor: '#00B4E2',
        },
    },
    divNotification: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'relative',
        top: '10px',
        right: '10px',
        height: '20px',
    },
    avatarNotification: {
        width: '20px',
        height: '20px',
        backgroundColor: theme.palette.error.main,
    },
    notificationIcon: {
        fontSize: '0.85rem',
    },
});

export default styles;
